import useUpdatePoolTaskSubmissions from '../../../../hooks/useUpdatePoolTaskSubmissions'
import TaskAllocationAmount from '../../../../shared_components/Missions/TaskAllocationAmount'
import SharedVerifyWalletTask, {
  Props,
} from '../../../../shared_components/Missions/Types/VerifyWallet'

export default function VerifyWalletTask(
  props: Omit<Props, 'updateTaskSubmissions' | 'taskAmount'>,
) {
  const updateTaskSubmissions = useUpdatePoolTaskSubmissions()
  return (
    <SharedVerifyWalletTask
      {...props}
      updateTaskSubmissions={updateTaskSubmissions}
      taskAmount={<TaskAllocationAmount taskId={props.taskId} />}
    />
  )
}
